import {
  collection,
  doc,
  getDoc,
  query,
  getDocs,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "shared/api/firebase";
import { Article, ArticleStatus, UpdateArticleStatusParams } from "../types";

export const updateArticleStatus = async ({
  brandId,
  categoryId,
  groupId,
  articleId,
  status,
  language,
}: UpdateArticleStatusParams): Promise<Article> => {

  const groupRef = collection(db, "legalDocuments", brandId, categoryId);

  const documentsRef = collection(groupRef, groupId, "documents");

  const groupDocRef = doc(groupRef, groupId);

  const docRef = doc(documentsRef, articleId);

  const publishedQuery = query(
    documentsRef,
    where("status", "==", ArticleStatus.PUBLISHED),
    where("language", "==", language),
  );

  const publishedDocs = await getDocs(publishedQuery);

  // Unpublish another article if the status is published
  try {
    if (status === ArticleStatus.PUBLISHED) {
      if (!publishedDocs.empty) {
        const publishedDoc = publishedDocs.docs[0];
        await updateDoc(doc(documentsRef, publishedDoc.id), {
          status: ArticleStatus.UNPUBLISHED,
          updatedAt: new Date(),
        });
      }
    }
  } catch (error) {
    console.error("Failed to update the article status:", error);
    throw error;
  }

  try {
    await Promise.all([
      updateDoc(docRef, { status, updatedAt: new Date() }),
      updateDoc(groupDocRef, {
        updatedAt: new Date(),
      }),
    ]);

    const updatedTagSnapshot = await getDoc(docRef);

    return updatedTagSnapshot.data() as Article;
  } catch (error) {
    console.error("Failed to update the article status:", error);
    throw error;
  }
};
